import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-academics-calendar',
  templateUrl: './academics-calendar.component.html',
  styleUrls: ['./academics-calendar.component.scss']
})
export class AcademicsCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
